import { ClientTag } from "@/components"
import { MetadataSectionContainer } from "@/components/MetadataSections/MetadataSectionContainer"
import { graphql, useFragment } from "@/gql"
import { ProjectClientSectionFragmentDoc, ProjectMetadataFragment } from "@/gql/graphql"

graphql(`
  fragment ProjectClientSection on CreativeWorkPortfolioProject {
    id
    associations {
      edges {
        node {
          id
          entity {
            id
            name
            avatarInitials
            avatar80w: avatarUrl(width: 80)
          }
        }
      }
    }
  }
`)

interface Props {
  project: ProjectMetadataFragment
}

export const ProjectClientSection: React.FC<Props> = props => {
  const project = useFragment(ProjectClientSectionFragmentDoc, props.project)
  const associations = project?.associations?.edges

  if (!associations || associations.length === 0) {
    return null
  }

  return (
    <div className="flex flex-wrap gap-2">
      {project?.associations?.edges?.map(edge => {
        const node = edge?.node
        const entity = node?.entity
        return (
          <ClientTag
            key={edge?.node?.id}
            name={entity?.name || node?.entity?.name}
            avatarInitials={entity?.avatarInitials}
            avatar80w={entity?.avatar80w}
          />
        )
      })}
    </div>
  )
}
